// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".6714116b0f7b5a7df9f6b1d9b83557b7.js";
};